<template>
  <el-dialog
    :title="computedTitle"
    :visible.sync="isdialog"
    width="50%"
    :before-close="handleClose"
    >
        <div class="update_password" v-if="type==1">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="90px">
                <el-form-item label="门店名称" prop="username">
                  <el-input v-model="username" disabled autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="门店账号" prop="account">
                  <el-input v-model="account" disabled autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                  <el-input v-model="form.password" autocomplete="off" :minlength="6" placeholder="长度限制6-20位" :maxlength="20" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="again_password">
                  <el-input v-model="form.again_password" autocomplete="off" :minlength="6" placeholder="长度限制6-20位" :maxlength="20" show-password clearable></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="update_password" v-if="type==2">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="90px">
                <el-form-item label="营业时间" prop="business_info">
                    <el-time-picker
                        is-range
                        v-model="form.business_info"
                        format="HH:mm"
                        value-format="HH:mm"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围" clearable>
                    </el-time-picker>
                </el-form-item>
            </el-form>
        </div>
        <div class="update_password" v-if="type==3">
            <el-radio v-model="form.business_status" label="1">
                <span>恢复营业</span>
                <p class="tips">按营业时间自动开关店，营业时间内正常接单，非营业时间内同城配送无法接单</p>
            </el-radio>
            <el-radio v-model="form.business_status" label="0" style="margin-top: 20px;">
                <span>临时休息</span>
                <p class="tips">向顾客展示店铺休息，设置后则暂时不支持接单（含同城、自提、物流）</p>
            </el-radio>
        </div>
        <div class="update_password" v-if="type==4">
            <el-radio v-model="form.status" label="1">
                <span>启用</span>
                <p class="tips">门店处于启用状态时，可正常开展各项运营活动，涵盖商品管理、订单接受等业务</p>
            </el-radio>
            <el-radio v-model="form.status" label="0" style="margin-top: 20px;">
                <span>禁用</span>
                <p class="tips">门店处于禁用状态时，所以运营活动将暂停，无法接受订单</p>
            </el-radio>
        </div>
        <div class="update_password" v-if="type==5">
            <el-image
            style="width: 100px; height: 100px"
            src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
            :fit="fit"></el-image>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submits('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
      name: 'Layout',
      props: {
        isdialog: Boolean,
        type:Number,
        username:String,
        account:String
      },
      data() {
            return {
                form:{
                    business_info:'',
                    merchant_id:'',
                    password:'',
                    again_password:'',
                    business_status:'1',
                    status:'1'
                },
                rules: {
                    business_info: [
                        { required: true, message: '请选择营业时间', trigger: 'change' },
                    ],
                    business_status: [
                        { required: true, message: '请选择营业状态', trigger: 'change' },
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                    again_password: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                },
                value1:'',
                radio:'1',
                title:'修改密码',
            }
        },
        computed: {
            computedTitle() {
                switch (this.type) {
                    case 1:
                    return '修改密码';
                    case 2:
                    return '设置营业时间';
                    case 3:
                    return '设置营业状态';
                    case 4:
                    return '设置门店状态';
                    case 5:
                    return '门店二维码';
                    default:
                    return '修改密码';
                }
            }
        },
        created(){

        },
        
        methods:{
            handleClose(){
                this.$emit('update-visible', false);
                this.form = {
                    password:'',
                    again_password:'',
                }
            },
            submits(formName){
                if(this.type == 1 || this.type == 2){
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            if(this.type == 1){
                                if(this.form.password !== this.form.again_password){
                                   this.$message.error('输入的两次密码不相同！');
                                }else{
                                    let obj = {
                                        type:1,
                                        password:this.form.password,
                                        again_password:this.form.again_password,
                                    }
                                    this.$emit('set-time', obj);
                                }
                            }else{
                                let obj = {
                                    type:2,
                                    value:this.form.business_info
                                }
                                this.$emit('set-time', obj);
                            }
                            
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                }else if(this.type == 3){
                    let obj = {
                        type:3,
                        value:this.form.business_status
                    }
                    this.$emit('set-time', obj);
                }else if(this.type == 4){
                    let obj = {
                        type:4,
                        value:this.form.status
                    }
                    this.$emit('set-time', obj);
                }
            },
        }
    }
</script>
<style lang="less" scoped>
.tips{
    margin-top: 5px;
}
</style>